const localizers = {
  'loading.msg': () => `טוען...`,
  'SASServer.genericError.msg': () => `לא ניתן להתחבר לשרת.`,
  'SASReport.genericError.msg': () => `לא ניתן לטעון את הדוח שנבחר.`,
  'SASReportImage.genericError.msg': () => `טעינת תמונת הדוח נכשלה.`,
  'SASReportImage.imageNotSupported.msg': () => `סוג תוכן דוח זה אינו תומך בתמונות.`,
}
export default localizers;
